export default __webpack_public_path__ + "static/media/search.cfdccef6.svg";